import { restoreCoupons } from "@/api/coupons";
import { CouponsQueryKeys } from "@/tanstackQuery/queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useRestoreCoupons = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: restoreCoupons,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [CouponsQueryKeys.Trash],
      });
    },
  });
};
